<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="title" center width="1000px"
    :close-on-click-modal="false" @close="whenDialogClose">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">
        <div class="mydialog df-c-fs">

          <div class="df-l-c-ct w100p">
            <div class="videoBox" :style="`width: ${videoWidth}px;height: ${videoHeight}px`">
              <div v-show="showNoCamera" class="df-l-c-ct h100p">
                <img src="@/assets/icons/no-camera.png" class="no-camera-icon p20">
                <div class="p20 f-s f-white">{{$t('login.noCameraWarning')}}</div>
              </div>
              <video id="video" autoplay :style="`width: ${videoWidth}px;height: ${videoHeight}px`" v-show="!showNoCamera"></video>
            </div>

            <!-- <canvas id="canvas" :width="videoWidth" :height="videoHeight"></canvas> -->
          </div>
          
        </div>
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <div class="themebtn" @click="submitDialog">{{title}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios';
export default {
  name: 'DialogCamera',
  props: ['title'],
  data() {
    return {
      isShowDialog: false,
      showNoCamera: false,
      videoStream: null,
      videoWidth: 960,
      videoHeight: 540,
      constraints: {
        video: {
          // width: this.videoWidth,
          // height: this.videoHeight,
          width: {
            min: this.videoWidth,
            ideal: 960,
            max: this.videoWidth,
          },
          height: {
            min: this.videoHeight,
            ideal: 540,
            max: this.videoHeight,
          },
          // width: {
          //   min: 1280,
          //   ideal: 1920,
          //   max: 2560,
          // },
          // height: {
          //   min: 720,
          //   ideal: 1080,
          //   max: 1440,
          // },
          // facingMode: 'user', // 访问前置摄像头
          // facingMode: 'environment', // 访问后置摄像头
          // 如果你想在已经播放视频的情况下更换摄像机，你需要先停止当前的视频流，然后再将其替换成另一台摄像机的视频流。
          // videoStream.getTracks().forEach((track) => {
          //   track.stop()
          // })
        },
      },
    }
  },
  methods: {
    open() {
      this.$tool.dsbridge_watch(this.$tool.dsbridge_map.cameraWatch, (data) => {
        // alert(data)
        this.$emit('submitDialog', data)
      })
      const RESULT = this.$tool.dsbridge_call(this.$tool.dsbridge_map.initMediaDevices, { shopId: this.shop_x.id })
      if (RESULT === null) {
        this.scan_canLeave_x_save(false)
        this.isShowDialog = true
        this.$nextTick(() => {
          this.initMediaDevices()
        })
      }
    },
    close() {
      this.isShowDialog = false
    },
    whenDialogClose() {
      // this.$emit('close')
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
    },

    // isSupportMediaDevices() {
    //   if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
    //     // ok, 浏览器支持它
    //     return true
    //   } else {
    //     return false
    //   }
    // },
    getUserMediaToPhoto(constraints, success, error) {
      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        //最新标准API
        navigator.mediaDevices.getUserMedia(constraints).then(success).catch(error)
      } else if (navigator.webkitGetUserMedia) {
        //webkit核心浏览器
        navigator.webkitGetUserMedia(constraints, success, error)
      } else if (navigator.mozGetUserMedia) {
        //firefox浏览器
        navigator.mozGetUserMedia(constraints, success, error)
      } else if (navigator.getUserMedia) {
        //旧版API
        navigator.getUserMedia(constraints, success, error)
      }
    },
    initMediaDevices() {
      // this.showNoCamera = true

      this.getUserMediaToPhoto(this.constraints, (stream) => {
        // console.log(`%c视频流初始化:`, 'color: #f0f;', stream)
        this.videoStream = stream
        const w = stream.getVideoTracks()[0].getSettings().width
        const h = stream.getVideoTracks()[0].getSettings().height
        // console.log(`%c视频流宽高:`, 'color: #f0f;', w, h)
        this.videoHeight = h / w * this.videoWidth

        this.showNoCamera = false
        const video = document.querySelector('#video')
        if (!video) {
          // console.log(`%cvideo元素不存在`, 'color: #f0f;')
          return
        }
        video.srcObject = stream
      }, (e) => {
        // console.log(e)
        this.showNoCamera = true
        return false
      })
    },
    closeMediaDevices() {
      this.videoStream && this.videoStream.getTracks().forEach((track) => {
        track.stop()
      });
      // console.log(`%c视频流关闭:`, 'color: #f0f;', this.stream)
    },
    async shootMediaDevices() {
      const video = document.querySelector('#video')
      // const canvas = document.querySelector('#canvas')
      // if (!canvas) return
      const canvas = document.createElement('canvas')
      canvas.width = this.videoWidth
      canvas.height = this.videoHeight
      canvas.getContext('2d').drawImage(video, 0, 0, this.videoWidth, this.videoHeight)
      const dataBase64 = canvas.toDataURL('image/png');
      // console.log(`%c图片资源:`, 'color: #f0f;', dataBase64)
      // this.$emit('submitDialog', dataBase64)

      const blob = this.base64ToBlob(dataBase64)
      const [filename, mimeType] = this.getFilenameAndMimetypeFromBase64(dataBase64)
      const file = new File([blob], filename, { type: mimeType })

      const result = await this.uploadFile(file)
      if (result === false) {
        this.$message.error(this.$t('common.uploadFailed'))
      } else {
        this.$emit('submitDialog', result.data.fileName)
        this.closeMediaDevices()
        this.close()
      }
    },
    submitDialog() {
      if (this.showNoCamera) {
        this.$emit('submitDialog', null)
        this.close()
      } else {
        this.shootMediaDevices()
      }
    },
    uploadFile(file) {
      const formData = new FormData(); // 创建FormData对象
      formData.append('file', file); // 添加图片文件到formData对象中
      
      return axios({
        method: 'post',
        url: `${process.env.VUE_APP_TARGET}/header/img/upload`, // API接口地址
        data: formData,
        headers: {'Content-Type': 'multipart/form-data'} // 设置请求头为multipart/form-data类型
      }).then((response) => {
        console.log("文件上传成功！");
        return response.data; // 返回上传成功后的响应数据
      }).catch((error) => {
        console.error("文件上传失败：", error);
        return false
      });
    },
    // base64 转换为 Blob 对象的方法
    base64ToBlob(base64Data) {
      const parts = base64Data.split(";base64,");
      const contentType = parts[0].split(":")[1];
      const raw = window.atob(parts[1]);
      const rawLength = raw.length;
      const uInt8Array = new Uint8Array(rawLength);
      for (let i = 0; i < rawLength; ++i) {
          uInt8Array[i] = raw.charCodeAt(i);
      }
      return new Blob([uInt8Array], { type: contentType });
    },
    // 从 base64 数据中获取文件名和 mime 类型
    getFilenameAndMimetypeFromBase64(base64Data) {
      const fileInfo = base64Data.split(';base64,')[0].substring(5).split(':');
      const mimeType = fileInfo[0];
      const filename = fileInfo[1];
      return [filename, mimeType];
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  .dialog-ctr{flex: 1;box-sizing: border-box;padding-bottom: 20px;}
  .videoBox{
    background: #2E2E2E;border-radius: 2px;margin: 20px;overflow: hidden;
    #video{float: right;}
    .no-camera-icon{width: 64px;height: 64px;}
  }
}
</style>